module.exports = __webpack_public_path__ + "img/cs-iosclub-4.59cc03ad.jpg";